import React, { forwardRef } from 'react'
import ConfirmPopup from './ConfirmPopup'

export default forwardRef(function WarningPopup(props, ref) {
    return (
        <ConfirmPopup
            type="warning"
            {...props}
            onDelete={props.onOk}
            ref={ref}
        />
    )
})
